const baseOrder = {
  ordereditems: {
    value: [],
  },
}

const state = {
  order: baseOrder,
}

const getters = {
  orderAttributes: (state, getters, rootState, rootGetters) => {
    return rootGetters['meta/getOrderAttributes']
  },
  orderedItemAttributes: (state, getters, rootState, rootGetters) => {
    return rootGetters['meta/getOrderedItemAttributes']
  },
  orderTemplate: (state, getters) => {
    const order = baseOrder
    for (const attr of getters.orderAttributes) {
      order[attr.name] = {
        category: attr.category,
        name: attr.name,
        value: attr.default,
      }
    }
    return order
  },
  orderedItemTemplate: (state, getters) => {
    const orderedItem = {}
    for (const attr of getters.orderedItemAttributes) {
      orderedItem[attr.name] = {
        category: attr.category,
        name: attr.name,
        value: attr.default,
      }
    }
    return orderedItem
  },
  orderedItems: (state) => {
    return state.order.ordereditems.value
  },
  hasOrderedItems: (state, getters) => {
    return getters.orderedItems.length > 0
  },
  numOrderedItems: (state, getters) => {
    return getters.orderedItems.length
  },
  hasOrderSet: (state) => {
    let isDefault
    const orderKeys = Object.keys(state.order)
    if (orderKeys.length === 1 && orderKeys[0] === 'ordereditems') {
      isDefault = true
    } else {
      isDefault = false
    }
    return !isDefault
  },
}

const actions = {
  initOrder({ commit, getters }) {
    commit('RESET_ORDER', getters.orderTemplate)
  },
  clearOrder({ commit }) {
    commit('CLEAR_ORDER')
  },
  changeOrder({ commit }, order) {
    commit('UPDATE_ORDER', {
      name: order.name,
      value: order.value,
    })
  },
  addOrderedItems({ commit, getters }, items) {
    const quantity = items.length
    if (quantity > 0) {
      if (!getters.hasOrderSet) {
        commit('RESET_ORDER', getters.orderTemplate)
      }
      commit('ADD_ORDERED_ITEMS', items)
      commit(
        'notify',
        {
          type: 'success',
          message: `Added ${quantity} item(s) to cart`,
        },
        { root: true },
      )
    }
  },
  changeOrderedItem({ commit }, item) {
    commit('UPDATE_ORDERED_ITEM', {
      index: item.index,
      name: item.name,
      value: item.value,
    })
  },
  removeOrderedItem({ commit }, item) {
    commit('REMOVE_ORDERED_ITEM', item.index)
  },
}

const mutations = {
  UPDATE_ORDER(state, { name, value }) {
    state.order = {
      ...state.order,
      [name]: {
        ...state.order[name],
        value: value,
      },
    }
  },
  ADD_ORDERED_ITEMS(state, items) {
    const existingItems = state.order.ordereditems.value
    state.order.ordereditems.value = [...existingItems, ...items]
  },
  UPDATE_ORDERED_ITEM(state, { index, name, value }) {
    state.order.ordereditems.value[index][name].value = value
  },
  REMOVE_ORDERED_ITEM(state, itemIndex) {
    state.order.ordereditems.value.splice(itemIndex, 1)
  },
  SET_ORDERED_ITEMS(state, items) {
    state.order.ordereditems.value = items
  },
  CLEAR_ORDER(state) {
    // Drop ordered items AND any persisted order-detail fields (name,
    // budget_number, external_id, …) so a new cart starts completely clean.
    state.order = { ordereditems: { value: [] } }
  },
  RESET_ORDER(state, orderTemplate) {
    delete state.order
    state.order = orderTemplate
  },
}

const orders = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}

export default orders
